import { keepPreviousData } from '@tanstack/react-query';
import { AGGREGATE_NAMES, LOAN_REQUEST_RESOLVERS } from 'cpool-constants';
import { schemaLoanRequestResolver_GetProcessedNotifications } from 'cpool-tables/backend-resolvers';

import { useAggregateQuery } from '~/queryUtils/useQuery';
import { useQueryPositionStore } from '~/store/queryPositionStore';
import { queryKeys } from '~/utils/queryKeys';

// notifications the user already handled - kept current by `useNotificationsSocket` pushes
export const useProcessedNotifications = () => {
    const queryKey = queryKeys.getProcessedNotifications();
    const queryPosition = useQueryPositionStore((state) => state.positions[JSON.stringify(queryKey)]);

    return useAggregateQuery({
        acl: {},
        aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
        resolverName: LOAN_REQUEST_RESOLVERS.getProcessedNotifications,
        schema: schemaLoanRequestResolver_GetProcessedNotifications,
        searchParams: { position: queryPosition },
        tanstack: {
            placeholderData: keepPreviousData,
        },
    });
};
